import React from 'react';

const SectionTitle = (props) => (
	<div className="component-title section_title" {...props}>
		{props.children}
	</div>
);

export default SectionTitle;
